module.exports = __webpack_public_path__ + "media/components/assets/icons/sale_basket-e5e5d8c72ebdc2a97b277ea566f6f5c6.svg";